import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Navigation } from "swiper";
import { Swiper, SwiperClass, SwiperSlide } from "swiper/react";
import { Wiki } from "../../context/wikiContext/types";
import AssetManager from "../AssetManager";
import useResolvedLang from "../hooks/useResolvedLang";

const WikiInfoCarousel: React.FC<WikiInfoCarouselProps> = ({
  wiki,
  backFunc,
  setOpen,
}) => {
  const [swiper, setSwiper] = useState<SwiperClass | null>(null);
  const [activeSlide, setActiveSlide] = useState<number>(1);

  const { i18n } = useTranslation();
  const lang = useResolvedLang();

  return (
    <div className="wiki-infos-container">
      <div className="wiki-info-card-header">
        <h3 className="wiki-info-card-title">{wiki.choice[lang]}</h3>
        <div
          className="wiki-modal-close"
          onClick={() => {
            setOpen(false);
            backFunc();
          }}
        >
          <img
            src={AssetManager.getAsset("/close_icon.svg")}
            alt="close-icon"
          />
        </div>
      </div>

      <Swiper
        modules={[Navigation]}
        navigation
        slidesPerView={1}
        onSwiper={(sw) => setSwiper(sw)}
        onSlideChange={(sw) => {
          setActiveSlide(sw.activeIndex + 1);
        }}
        direction="horizontal"
      >
        {wiki.infos.map((info, index) => (
          <SwiperSlide key={index}>
            <div className="wiki-info-card">
              <img
                src={AssetManager.getWikiAsset(info.imageUrl)}
                alt="wiki_info_image"
                className="wiki-info-card-image"
              />

              <div className="wiki-info-card-details">
                <h4 className="wiki-info-card-subtitle">{info.title[lang]}</h4>
                <p className="wiki-info-card-description">
                  {info.subtitle[lang]}
                </p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <p className="wiki-info-card-back" onClick={backFunc}>
        {i18n.t("wiki_modal_back_to_question")}
      </p>
      <div className="wiki-info-card-footer">
        <div className="circle-big"></div>
        <div className="circle-medium"></div>
        <div className="circle-small"></div>
        <p className="wiki-info-card-page">
          {activeSlide}/{wiki.infos.length}
        </p>
        <div className="circle-small"></div>
        <div className="circle-medium"></div>
        <div className="circle-big"></div>
      </div>
    </div>
  );
};

export default WikiInfoCarousel;

export interface WikiInfoCarouselProps {
  wiki: Wiki;
  backFunc: () => void;
  setOpen: (open: boolean) => void;
}
